export enum SimulatorEvents {
  TRAINING_INQUIRY_OPENED = "simulator_training_inquiry_opened",
  TRAINING_INQUIRY_SELF_CREATED = "simulator_training_inquiry_self_created",
  CREATED = "simulator_created",
  DELETED = "simulator_deleted",
  GOOD_FEEDBACK = "simulator_good_feedback",
  BAD_FEEDBACK = "simulator_bad_feedback",
  START_INSTRUCTION = "simulator_start_instruction",
  SUBMIT_INSTRUCTION = "simulator_submit_instruction",
  DELETE_INSTRUCTION = "simulator_delete_instruction",
  CHECK_SOURCES = "simulator_check_sources",
  ENTER_EDIT_MODE = "simulator_enter_edit_mode",
  SAVE_EDIT_MODE = "simulator_save_edit_mode",
  RELEASED = "simulator_released",
  START_BRIEF = "simulator_start_brief",
  SUBMIT_BRIEF = "simulator_submit_brief",
  CANCEL_BRIEF = "simulator_cancel_brief",
  MESSAGE_TRANSLATED = "simulator_message_translated",
  REGENERATE = "simulator_regenerate",
  DELETE_PRE_REQUISITE = "simulator_delete_pre_requisite",
  CHAT_STARTED = "simulator_chat_started",
  MESSAGE_SENT = "simulator_message_sent",
  MESSAGE_RECEIVED = "simulator_message_received",
  SESSION_ENDED = "simulator_session_ended",
  INSTRUCTION_ADDED = "simulator_instruction_added",
  FEEDBACK_PROVIDED = "simulator_feedback_provided",
  RELEASE_CREATED = "simulator_release_created",
  TOPIC_VIEWED = "simulator_topic_viewed",
  SESSION_STARTED = "simulator_session_started",
  TRAINING_DATA_ADDED = "simulator_training_data_added",
}